import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ScrollTopComponent } from '@shared/components/utilities/scroll-top/scroll-top.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ScrollTopComponent],
    templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'inlightened';
}
